import { handleActions } from 'redux-actions';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { combineReducers } from 'redux';
import { filters as filtersAPI } from 'api';
import { getEntities } from 'selectors';
import { filters } from 'schemas';
import { getFiltersListApiHOC } from '../selectors';
import { types } from './actions';

export const getIsFetching = state => getFiltersListApiHOC(state).isFetching;

export const getFilters = createSelector(
  state => getFiltersListApiHOC(state).result,
  state => getEntities(state),

  (result, entities) => denormalize(
    result,
    filters.arrayOfFilterSchemas,
    entities,
  ),
);

const bannedFilters = ['color']; // these filters don't need to be included to main page

const sortFiltersByType = (array, withBanned) => array
  .reduce((acc, filter) => {
    if (!withBanned && bannedFilters.includes(filter.type)) {
      return acc;
    }
    acc[filter.type] = acc[filter.type] ? [...acc[filter.type], filter] : [filter];
    return acc;
  }, {});

export const getMainFiltersByGroup = createSelector(
  getFilters,
  items => sortFiltersByType(items, false),
);

export const getAllFiltersByGroup = createSelector(
  getFilters,
  items => sortFiltersByType(items, true),
);

export default combineReducers({
  isFetching: handleActions({
    [filtersAPI.types.GET_FILTERS_REQUEST]: () => true,
    [filtersAPI.types.GET_FILTERS_SUCCESS]: () => false,
    [filtersAPI.types.GET_FILTERS_FAILURE]: () => false,
  }, false),

  result: handleActions({
    [filtersAPI.types.GET_FILTERS_SUCCESS]: (state, { payload: { result } }) => result,
    [types.FILTERS_LIST_API_HOC_RESET]: () => null,
  }, []),
});



// WEBPACK FOOTER //
// ./src/components/apiHOCs/FiltersListApiHOC/reducers.js